module.exports = __webpack_public_path__ + "static/media/EHL.2c32354a.svg";